import Immutable from 'immutable';

import ErrorData from 'sharedreact/data/ErrorData';
import type Filter from 'sharedreact/data/Filter';
import type GroupAndCount from 'sharedreact/data/GroupAndCount';
import type SortOrder from 'sharedreact/data/SortOrder';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import type { RangeType } from 'sharedreact/stores/generic/Type';
import type AuditRecord from 'sharedreact/data/AuditRecord';

import AuditConnection from 'workspaces/launcher/connections/AuditConnection';
import AuditConstants from 'workspaces/launcher/constants/AuditConstants';

function _fetchSuccess (
  range: RangeType,
  totalCount: number,
  items: Immutable.List<AuditRecord>,
  countPerGroup: Immutable.List<GroupAndCount>,
  filter: Filter,
  advancedFilter: Filter,
  groupBy: SortOrder,
  sortOrder: SortOrder
): void {
  AppDispatcher.dispatch({
    actionType: AuditConstants.GET_SUCCESS,
    range: range,
    totalCount: totalCount,
    items: items,
    countPerGroup: countPerGroup,
    filter: filter,
    advancedFilter: advancedFilter,
    groupBy: groupBy,
    sortOrder: sortOrder,
    logLevel: 'debug'
  });
}

function _fetchFailure (error: ErrorData): void {
  AppDispatcher.dispatch({
    actionType: AuditConstants.GET_FAIL,
    error: error,
    logLevel: 'error'
  });
}

function fetch (
  range: RangeType,
  filter: Filter,
  advancedFilter: Filter,
  groupBy: SortOrder,
  sortOrder: SortOrder,
  isInitialFetch: boolean
): void {
  AuditConnection.fetch(
    range,
    filter,
    advancedFilter,
    groupBy,
    sortOrder,
    isInitialFetch,
    _fetchSuccess,
    _fetchFailure
  );
}

function setVisibleRange (range: RangeType): void {
  AppDispatcher.dispatch({
    actionType: AuditConstants.SET_VISIBLE_RANGE,
    range: range,
    logLevel: 'trace'
  });
}

function setSortOrder (sortOrder: SortOrder): void {
  AppDispatcher.dispatch({
    actionType: AuditConstants.SET_SORTORDER,
    sortOrder: sortOrder,
    logLevel: 'trace'
  });
}

function activateFilter (filterMode: string): void {
  AppDispatcher.dispatch({
    actionType: AuditConstants.ACTIVATE_FILTER,
    filterMode: filterMode,
    logLevel: 'trace'
  });
}

function setFilter (filterMode: string, filter: Filter, filterString: string): void {
  AppDispatcher.dispatch({
    actionType: AuditConstants.SET_FILTER,
    filterMode: filterMode,
    filter: filter,
    filterString: filterString,
    logLevel: 'trace'
  });
}

function refresh (): void {
  AppDispatcher.dispatch({
    actionType: AuditConstants.REFRESH,
    logLevel: 'trace'
  });
}

export default {
  fetch,
  setVisibleRange,
  setSortOrder,
  setFilter,
  activateFilter,
  refresh
};
